<template>
  <div>
    <PageMain
      ref="main"
      :tableData="tableData"
      :disabled="disabled"
      :loading="loading"
      @reload="getData"
    >
      <PageHeader
        ref="header"
        slot="header"
        :disabled="disabled"
        @openChooseSample="onOpenChooseSample"
      >
      </PageHeader>
    </PageMain>
    <ChooseSample
      v-if="chooseSampleVisible"
      :visible="chooseSampleVisible"
      :custCode="custCode"
      @close="onCloseChooseSample"
      @chooseSample="onChooseSample"
    ></ChooseSample>
  </div>
</template>
<script>
import PageHeader from './header.vue'
import PageMain from './main.vue'
import ChooseSample from './components/choose-sample'
import EditLoading from '@/mixins/edit-loading'
export default {
  mixins: [EditLoading],
  components: { PageHeader, PageMain, ChooseSample },
  props: {
    sendSampleCode: {
      type: String,
      default: '',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      loading: false,
      tableData: [],
      chooseSampleVisible: false,
      custCode: '',
    }
  },
  async mounted() {
    await this.getDetail()
    await this.getData()
  },
  methods: {
    onOpenChooseSample() {
      this.chooseSampleVisible = true
    },
    onCloseChooseSample() {
      this.chooseSampleVisible = false
    },
    onChooseSample(data) {
      if (this.loadingOpen()) return
      const samples = data.map((e) => {
        return {
          ...e,
          qty: 1,
          goodsSizeSpec: e.sampleSize || '',
          fabricDesc: e.sampleContent || '',
          sampleSpecName: e.originalSampleName || '',
          sampleSpecNameEn: e.originalSampleNameEn || '',
          sendSampleCode: this.sendSampleCode,
          scmCode: e.sampleScmCode,
        }
      })

      this.$api
        .customerSendSampleDetailSaveBatchApi({
          samples,
        })
        .then((res) => {
          this.getData()
          this.loadingClose()
          const { status } = res
          if (status == 200) {
            this.onCloseChooseSample()
          }
        })
        .catch(() => {
          this.loadingClose()
        })
    },
    async getDetail() {
      if (!this.sendSampleCode) return
      const data = await this.$api
        .customerSendSampleDetailApi({ sendSampleCode: this.sendSampleCode })
        .then((res) => res.body)
        .catch(() => null)
      if (!data) return
      this.custCode = data.custCode || ''
    },
    async getData() {
      if (!this.sendSampleCode) return
      this.loading = true
      const res = await this.$api
        .customerSendSampleDetailListApi({
          sendSampleCode: this.sendSampleCode,
        })
        .then((res) => res.body)
        .catch(() => null)
      this.loading = false
      if (!res) return
      this.tableData = res?.data || []
    },
  },
}
</script>
